import axios from "axios";

const BASEURL = "https://flooringdeals.ca/api";
// const BASEURL = "http://localhost:5001/api";

const AppInstance = axios.create({
  baseURL: BASEURL,
});
const cancelTokenSource = axios.CancelToken.source();

AppInstance.interceptors.request.use(
  (request) => {
    // Only set Content-Type for JSON requests, not for FormData
    if (!(request.data instanceof FormData)) {
      request.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    request.headers["Accept"] = "application/json";
    request.cancelToken = cancelTokenSource.token;
    const user = localStorage.getItem("user");

    if (user) {
      const userObject = JSON.parse(user);
      request.headers["Authorization"] = `Bearer ${userObject.token}`;
    }
    return request;
  },
  (error) => {
    console.error("Request error in axios interceptor:", error.message);
    throw error.message;
  }
);

AppInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
      throw error.message;
    } else {
      throw error.response.data;
    }
  }
);

export default AppInstance;
